import React from 'react'
import { Link } from 'react-router-dom'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const Login = () => {
  return (
    <>
        <Meta title='Login'/>
        <BreadCrum title='Login' />
        <Container class1="login-wrapper py-3 home-wrapper-2">
            <div className="row">
                <div className="col-12">
                    <div className="auth-card">
                        <h3 className='text-center mb-3'>Login</h3>
                        <form action="" className='d-flex flex-column gap-15'>
                            <div>
                                <input type="email" name='email' placeholder='Email' className="form-control" />
                            </div>
                            <div className='mt-1'>
                                <input type="password" name='password' placeholder='Password' className="form-control" />
                            </div>
                            <div>
                                <Link to="/forgot-password">Forgot Password?</Link>
                                <div className="mt-3 d-flex justify-content-center gap-15 align-items-center">
                                    <button type='submit' className="button border-0">Login</button>
                                    <Link to='/signup' className='button signup border-0'>SignUp</Link>            
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
        </Container>
    </>
  )
}

export default Login